import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import acordLogo from 'images/acordlogo.png';
import CreateNewCarriers from '../CreateNewCarriers';
import AddNewSignature from '../AddNewSignature';
import { useSignatures } from '../../../../hooks/useSignatures';
import ProducerSection, { fetchPolicyAgentContact } from '../ProducerSection';
import InsurerSearchDropdown from '../InsurerSearchDropdown';
import { formatUsPhone } from 'utilities/formatPhone';

const INSR_OPTIONS = ['A','B','C','D','E','F'].map(l => ({ label: l, value: l }));

interface Acord23FormProps { selectedPolicies?: string[]; insuredId?: string; }

export default function Acord23Form({ selectedPolicies = [], insuredId = '' }: Acord23FormProps) {
  const [showCreateCarrier, setShowCreateCarrier] = React.useState(false);
  const [showAddSignature, setShowAddSignature] = React.useState(false);

  const [producerAddress, setProducerAddress] = React.useState('');
  const [producerCity, setProducerCity] = React.useState('');
  const [producerState, setProducerState] = React.useState('');
  const [producerZip, setProducerZip] = React.useState('');
  const [producerStreet, setProducerStreet] = React.useState('');

  const [contactName, setContactName] = React.useState('');
  const [contactPhone, setContactPhone] = React.useState('');
  const [contactFax, setContactFax] = React.useState('');
  const [contactEmail, setContactEmail] = React.useState('');
  const [producerCustomerId, setProducerCustomerId] = React.useState('');

  const [insuredName, setInsuredName] = React.useState('');
  const [insuredAddress, setInsuredAddress] = React.useState('');
  const [insuredCity, setInsuredCity] = React.useState('');
  const [insuredState, setInsuredState] = React.useState('');
  const [insuredZip, setInsuredZip] = React.useState('');

  const [insurerA, setInsurerA] = React.useState('');
  const [insurerB, setInsurerB] = React.useState('');
  const [insurerC, setInsurerC] = React.useState('');
  const [insurerD, setInsurerD] = React.useState('');
  const [insurerE, setInsurerE] = React.useState('');
  const [insurerF, setInsurerF] = React.useState('');

  const [certDate, setCertDate] = React.useState<Date | null>(new Date());

  const [vehicleYear, setVehicleYear] = React.useState('');
  const [vehicleMake, setVehicleMake] = React.useState('');
  const [vehicleModel, setVehicleModel] = React.useState('');
  const [vehicleBodyType, setVehicleBodyType] = React.useState('');
  const [vehicleVin, setVehicleVin] = React.useState('');
  const [vehicleDescription, setVehicleDescription] = React.useState('');
  const [vehicleSerialNumber, setVehicleSerialNumber] = React.useState('');

  const [certNumber, setCertNumber] = React.useState('');
  const [revisionNumber, setRevisionNumber] = React.useState('');

  const [vlInsrLtr, setVlInsrLtr] = React.useState('');
  const [vlAddlInsrd, setVlAddlInsrd] = React.useState(false);
  const [vlPolicyNum, setVlPolicyNum] = React.useState('');
  const [vlEffDate, setVlEffDate] = React.useState<Date | null>(null);
  const [vlExpDate, setVlExpDate] = React.useState<Date | null>(null);

  const [glInsrLtr, setGlInsrLtr] = React.useState('');
  const [glAddlInsrd, setGlAddlInsrd] = React.useState(false);
  const [glOccurrence, setGlOccurrence] = React.useState(false);
  const [glClaimsMade, setGlClaimsMade] = React.useState(false);
  const [glPolicyNum, setGlPolicyNum] = React.useState('');
  const [glEffDate, setGlEffDate] = React.useState<Date | null>(null);
  const [glExpDate, setGlExpDate] = React.useState<Date | null>(null);

  const [vclInsrLtr, setVclInsrLtr] = React.useState('');
  const [vclLossPayee, setVclLossPayee] = React.useState(false);
  const [vclChecked, setVclChecked] = React.useState(false);
  const [vclPolicyNum, setVclPolicyNum] = React.useState('');
  const [vclEffDate, setVclEffDate] = React.useState<Date | null>(null);
  const [vclExpDate, setVclExpDate] = React.useState<Date | null>(null);
  const [vclAcv, setVclAcv] = React.useState(false);
  const [vclAgreedAmt, setVclAgreedAmt] = React.useState(false);
  const [vclStatedAmt, setVclStatedAmt] = React.useState(false);

  const [vcInsrLtr, setVcInsrLtr] = React.useState('');
  const [vcLossPayee, setVcLossPayee] = React.useState(false);
  const [vcVehComp, setVcVehComp] = React.useState(false);
  const [vcVehOtc, setVcVehOtc] = React.useState(false);
  const [vcPolicyNum, setVcPolicyNum] = React.useState('');
  const [vcEffDate, setVcEffDate] = React.useState<Date | null>(null);
  const [vcExpDate, setVcExpDate] = React.useState<Date | null>(null);
  const [vcAcv, setVcAcv] = React.useState(false);
  const [vcAgreedAmt, setVcAgreedAmt] = React.useState(false);
  const [vcStatedAmt, setVcStatedAmt] = React.useState(false);

  const [propInsrLtr, setPropInsrLtr] = React.useState('');
  const [propLossPayee, setPropLossPayee] = React.useState(false);
  const [propBasic, setPropBasic] = React.useState(false);
  const [propSpecial, setPropSpecial] = React.useState(false);
  const [propBroad, setPropBroad] = React.useState(false);
  const [propPolicyNum, setPropPolicyNum] = React.useState('');
  const [propEffDate, setPropEffDate] = React.useState<Date | null>(null);
  const [propExpDate, setPropExpDate] = React.useState<Date | null>(null);
  const [propAcv, setPropAcv] = React.useState(false);
  const [propRc, setPropRc] = React.useState(false);
  const [propAgreedAmt, setPropAgreedAmt] = React.useState(false);
  const [propStatedAmt, setPropStatedAmt] = React.useState(false);

  const [genInsrLtr, setGenInsrLtr] = React.useState('');
  const [genLossPayee, setGenLossPayee] = React.useState(false);
  const [genPolicyNum, setGenPolicyNum] = React.useState('');
  const [genEffDate, setGenEffDate] = React.useState<Date | null>(null);
  const [genExpDate, setGenExpDate] = React.useState<Date | null>(null);
  const [remarks, setRemarks] = React.useState('');
  const [aiOption, setAiOption] = React.useState('');
  const [aiLeased, setAiLeased] = React.useState(false);
  const [aiFinanced, setAiFinanced] = React.useState(false);
  const [aiName, setAiName] = React.useState('');
  const [aiAddress1, setAiAddress1] = React.useState('');
  const [aiAddress2, setAiAddress2] = React.useState('');
  const [aiAddress3, setAiAddress3] = React.useState('');
  const [aiCity, setAiCity] = React.useState('');
  const [aiState, setAiState] = React.useState('');
  const [aiZip, setAiZip] = React.useState('');

  const [cancAddlInsured, setCancAddlInsured] = React.useState(false);
  const [cancLossPayee, setCancLossPayee] = React.useState(false);
  const [cancLendersLossPayee, setCancLendersLossPayee] = React.useState(false);
  const [loanLeaseNumber, setLoanLeaseNumber] = React.useState('');
  const [authRepSignature, setAuthRepSignature] = React.useState('');
  const { signatureOptions, refetchSignatures } = useSignatures();
  const [signaturePreviewUrl, setSignaturePreviewUrl] = React.useState('');
  React.useEffect(() => {
    if (!authRepSignature) { setSignaturePreviewUrl(''); return; }
    fetch(`${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/signature-preview/${authRepSignature}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
        'Content-Type': 'application/json',
        NCToken: localStorage.getItem('NCToken') || '',
      },
    })
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(url => setSignaturePreviewUrl(url.replace(/^"|"$/g, '')))
      .catch(() => setSignaturePreviewUrl(''));
  }, [authRepSignature]);

  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    let cancelled = false;
    const fetchCoverages = async () => {
      try {
        const ncToken = localStorage.getItem('NCToken') || '';
        const igToken = localStorage.getItem('igtoken') || '';
        const res = await fetch(
          `${process.env.REACT_APP_COIPortal_Url}/api/IGIGCOI/get-coverages`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'NCToken': ncToken,
              Authorization: `Bearer ${igToken}`,
            },
            body: JSON.stringify({
              policiesIds: selectedPolicies,
              truckingCompanyId: insuredId || '',
              fileParentId: 'BA40013E-110D-48BC-A864-1129B9583510',
              naics: [{ Code: '', Name: '' }],
              Page: 'certificateFiller',
            }),
          }
        );
        if (cancelled) return;
        await res.json();
      } catch {
        // silently fail — user can still fill manually
      }
    };
    fetchCoverages();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPolicies, insuredId]);

  // Prefill contact section from the first selected policy's agent
  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    fetchPolicyAgentContact(selectedPolicies[0]).then(({ name, phone, fax, email }) => {
      if (name) setContactName(name);
      if (phone) setContactPhone(phone);
      if (fax) setContactFax(fax);
      if (email) setContactEmail(email);
    });
  }, [selectedPolicies]);

  const chk = (id: string, label: string, checked: boolean, onChange: (v: boolean) => void) => (
    <div className="masterCert__checkboxItem">
      <Checkbox inputId={id} checked={checked} onChange={(e) => onChange(e.checked ?? false)} />
      <label htmlFor={id} className="masterCert__checkboxItemLabel">{label}</label>
    </div>
  );

  const limitRow = (label: string) => (
    <div className="acord23__limitRow">
      <span className="acord23__limitLabel">{label}</span>
      <span className="acord23__limitDollar">$</span>
      <InputText className="masterCert__input" style={{ width: 70 }} />
    </div>
  );

  const pdLimitsBlock = (
    acv: boolean, setAcv: (v: boolean) => void,
    agreedAmt: boolean, setAgreedAmt: (v: boolean) => void,
    statedAmt: boolean, setStatedAmt: (v: boolean) => void,
    showRc?: boolean,
    rc?: boolean, setRc?: (v: boolean) => void,
  ) => (
    <div className="acord23__limitsStack">
      <div className="acord23__limitRow">
        {chk(`pdAcv_${Math.random()}`, 'ACV', acv, setAcv)}
        {showRc && rc !== undefined && setRc && chk(`pdRc_${Math.random()}`, 'RC', rc, setRc)}
        <Checkbox checked={false} />
        <InputText className="masterCert__input" style={{ width: 50 }} />
      </div>
      <div className="acord23__limitRow">
        <span className="acord23__limitDollar">$</span>
        <InputText className="masterCert__input" style={{ width: 65 }} />
        <span className="acord23__limitTag">LIMIT</span>
      </div>
      <div className="acord23__limitRow">
        <span className="acord23__limitDollar">$</span>
        <InputText className="masterCert__input" style={{ width: 65 }} />
        <span className="acord23__limitTag">DED</span>
      </div>
      <div className="acord23__limitRow">
        {chk(`pdAgreed_${Math.random()}`, 'AGREED AMT', agreedAmt, setAgreedAmt)}
      </div>
      <div className="acord23__limitRow">
        {chk(`pdStated_${Math.random()}`, 'STATED AMT', statedAmt, setStatedAmt)}
      </div>
    </div>
  );

  return (
    <>
      <div className="masterCert__section">
        {/* ── ACORD Header ── */}
        <div className="masterCert__acordHeader">
          <img src={acordLogo} alt="ACORD" className="masterCert__acordLogo" />
          <div className="masterCert__acordTitleWrapper">
            <div className="masterCert__acordTitle">VEHICLE OR EQUIPMENT CERTIFICATE OF INSURANCE</div>
          </div>
          <div className="masterCert__dateWrapper">
            <div className="masterCert__dateLabel">DATE (MM/DD/YYYY)</div>
            <div className="masterCert__dateCell">
              <Calendar value={certDate} onChange={(e) => setCertDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
          </div>
        </div>

        <div className="masterCert__disclaimer">
          This certificate is issued as a matter of information only and confers no rights upon the certificate holder. This certificate does not affirmatively or negatively amend, extend or alter the coverage afforded by the policies below. This certificate of insurance does not constitute a contract between the issuing insurer(s), authorized representative or producer, and the certificate holder.
        </div>
        <div className="acord23__note">
          This form is used to report coverages provided to a single specific vehicle or equipment. Do not use this form to report liability coverage provided to multiple vehicles under a single policy. Use ACORD 25 for that purpose.
        </div>

        <div className="masterCert__twoColumnLayout">
          <div>
            <ProducerSection
              address={producerAddress}
              onAddressChange={setProducerAddress}
              city={producerCity}
              onCityChange={setProducerCity}
              street={producerStreet}
              onStreetChange={setProducerStreet}
              state={producerState}
              onStateChange={setProducerState}
              zip={producerZip}
              onZipChange={setProducerZip}
              onAgentContact={(phone, fax, email) => { setContactPhone(phone); setContactFax(fax); setContactEmail(email); }}
              readOnly
            />
            <div style={{ marginBottom: 16 }}>
              <div className="masterCert__sectionHeader">INSURED</div>
              <Dropdown value={insuredName} onChange={(e) => setInsuredName(e.value)} options={[]} placeholder="Type and/or choose location" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" editable disabled emptyMessage="No available options" />
              <InputText maxLength={100} value={insuredAddress} onChange={(e) => setInsuredAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" readOnly />
              <InputText className="masterCert__input masterCert__inputFull masterCert__inputMbSm" placeholder="Address line 2" />
              <div className="masterCert__addressGrid">
                <InputText maxLength={100} value={insuredCity} onChange={(e) => setInsuredCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={50} value={insuredState} onChange={(e) => setInsuredState(e.target.value)} placeholder="State" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={20} value={insuredZip} onChange={(e) => setInsuredZip(e.target.value)} placeholder="Zip" className="masterCert__input masterCert__inputFull" readOnly />
              </div>
            </div>
          </div>

          <div>
            <div style={{ marginBottom: 16 }}>
              <div className="masterCert__contactGrid">
                <div>
                  <div className="masterCert__contactLabel">CONTACT NAME:</div>
                  <InputText maxLength={100} value={contactName} onChange={(e) => setContactName(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div></div>
                <div>
                  <div className="masterCert__contactLabel">PHONE (A/C, No, Ext):</div>
                  <InputText value={formatUsPhone(contactPhone)} onChange={(e) => setContactPhone(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div>
                  <div className="masterCert__contactLabel">FAX (A/C, No):</div>
                  <InputText value={formatUsPhone(contactFax)} onChange={(e) => setContactFax(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div className="masterCert__contactLabel">E-MAIL ADDRESS:</div>
                <InputText maxLength={100} value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
              </div>
              <div style={{ marginTop: 6 }}>
                <div className="masterCert__contactLabel">PRODUCER CUSTOMER ID #:</div>
                <InputText maxLength={30} value={producerCustomerId} onChange={(e) => setProducerCustomerId(e.target.value)} className="masterCert__input masterCert__inputFull" />
              </div>
            </div>

            <div>
              <div className="masterCert__sectionHeader" style={{ marginBottom: 8 }}>INSURERS AFFORDING COVERAGE (and NAIC #)</div>
              <div className="masterCert__insurersGrid">
                <div className="masterCert__insurerLabel">INSURER A</div>
                <InsurerSearchDropdown value={insurerA} onChange={setInsurerA} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER B</div>
                <InsurerSearchDropdown value={insurerB} onChange={setInsurerB} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER C</div>
                <InsurerSearchDropdown value={insurerC} onChange={setInsurerC} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER D</div>
                <InsurerSearchDropdown value={insurerD} onChange={setInsurerD} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER E</div>
                <InsurerSearchDropdown value={insurerE} onChange={setInsurerE} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER F</div>
                <InsurerSearchDropdown value={insurerF} onChange={setInsurerF} className="masterCert__input masterCert__inputFull" />
              </div>
              <Button label="Add New" className="p-button-outlined carrierDialog__secondaryBtn" style={{ marginTop: 6 }} onClick={() => setShowCreateCarrier(true)} />
            </div>
          </div>
        </div>

        <div className="acord20__sectionTitle">DESCRIPTION OF VEHICLE OR EQUIPMENT</div>

        <div className="acord23__vehicleHeader">
          <div>YEAR</div>
          <div>MAKE</div>
          <div>MODEL</div>
          <div>BODY TYPE</div>
          <div>VEHICLE IDENTIFICATION NUMBER</div>
        </div>
        <div className="acord23__vehicleRow">
          <InputText maxLength={50} value={vehicleYear} onChange={(e) => setVehicleYear(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <InputText maxLength={50} value={vehicleMake} onChange={(e) => setVehicleMake(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <InputText maxLength={50} value={vehicleModel} onChange={(e) => setVehicleModel(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <InputText maxLength={50} value={vehicleBodyType} onChange={(e) => setVehicleBodyType(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <InputText maxLength={50} value={vehicleVin} onChange={(e) => setVehicleVin(e.target.value)} className="masterCert__input masterCert__inputFull" />
        </div>
        <div className="acord23__descRow">
          <div>
            <div className="masterCert__contactLabel" style={{ marginBottom: 4 }}>DESCRIPTION</div>
            <InputText maxLength={50} value={vehicleDescription} onChange={(e) => setVehicleDescription(e.target.value)} className="masterCert__input masterCert__inputFull" />
          </div>
          <div>
            <div className="masterCert__contactLabel" style={{ marginBottom: 4 }}>SERIAL NUMBER</div>
            <InputText maxLength={50} value={vehicleSerialNumber} onChange={(e) => setVehicleSerialNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
          </div>
        </div>

        <div className="acord20__sectionTitle">COVERAGES</div>

        <div className="masterCert__certNumberGrid">
          <div>
            <div className="masterCert__contactLabel">CERTIFICATE NUMBER:</div>
            <InputText maxLength={30} value={certNumber} onChange={(e) => setCertNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
          </div>
          <div>
            <div className="masterCert__contactLabel">REVISION NUMBER:</div>
            <InputText maxLength={30} value={revisionNumber} onChange={(e) => setRevisionNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
          </div>
        </div>

        <div className="masterCert__disclaimer" style={{ marginTop: 8, marginBottom: 8 }}>
          This is to certify that the policy(ies) of insurance listed below has/have been issued to the insured named above for the policy period(s) indicated, notwithstanding any requirement, term or condition of any contract or other document with respect to which this certificate may be issued or may pertain, the insurance afforded by the policy(ies) described herein is/are subject to all the terms, exclusions and conditions of such policy(ies).
        </div>

        <div className="acord23__covHeader">
          <div>INSR<br/>LTR</div>
          <div>ADD'L<br/>INSRD</div>
          <div style={{ textAlign: 'left' }}>TYPE OF INSURANCE</div>
          <div>POLICY NUMBER</div>
          <div>POLICY EFFECTIVE<br/>DATE (MM/DD/YY)</div>
          <div>POLICY EXPIRATION<br/>DATE (MM/DD/YY)</div>
          <div style={{ textAlign: 'left' }}>LIMITS</div>
        </div>

        <div className="acord23__covRow">
          <Dropdown value={vlInsrLtr} onChange={(e) => setVlInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={vlAddlInsrd} onChange={(e) => setVlAddlInsrd(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            <div className="masterCert__checkboxItem">
              <Checkbox checked={false} />
              <span className="masterCert__checkboxItemLabel" style={{ fontWeight: 600 }}>VEHICLE LIABILITY</span>
            </div>
          </div>
          <InputText value={vlPolicyNum} onChange={(e) => setVlPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={vlEffDate} onChange={(e) => setVlEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={vlExpDate} onChange={(e) => setVlExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <div className="acord23__limitsStack">
            {limitRow('COMBINED SINGLE LIMIT')}
            {limitRow('BODILY INJURY (Per person)')}
            {limitRow('BODILY INJURY (Per accident)')}
            {limitRow('PROPERTY DAMAGE')}
          </div>
        </div>

        <div className="acord23__covRow">
          <Dropdown value={glInsrLtr} onChange={(e) => setGlInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={glAddlInsrd} onChange={(e) => setGlAddlInsrd(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            <span className="acord23__typeLabel">GENERAL LIABILITY</span>
            {chk('a23GlOcc', 'OCCURRENCE', glOccurrence, setGlOccurrence)}
            {chk('a23GlCm', 'CLAIMS MADE', glClaimsMade, setGlClaimsMade)}
          </div>
          <InputText value={glPolicyNum} onChange={(e) => setGlPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={glEffDate} onChange={(e) => setGlEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={glExpDate} onChange={(e) => setGlExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <div className="acord23__limitsStack">
            {limitRow('EACH OCCURRENCE')}
            {limitRow('GENERAL AGGREGATE')}
            <div className="acord23__limitRow">
              <InputText className="masterCert__input" style={{ width: 90 }} />
              <span className="acord23__limitDollar">$</span>
              <InputText className="masterCert__input" style={{ width: 70 }} />
            </div>
          </div>
        </div>

        <div className="acord23__covHeader" style={{ marginTop: 16 }}>
          <div>INSR<br/>LTR</div>
          <div>LOSS<br/>PAYEE</div>
          <div style={{ textAlign: 'left' }}>TYPE OF INSURANCE</div>
          <div>POLICY NUMBER</div>
          <div>POLICY EFFECTIVE<br/>DATE (MM/DD/YY)</div>
          <div>POLICY EXPIRATION<br/>DATE (MM/DD/YY)</div>
          <div style={{ textAlign: 'left' }}>LIMITS / DEDUCTIBLE</div>
        </div>

        <div className="acord23__covRow">
          <Dropdown value={vclInsrLtr} onChange={(e) => setVclInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={vclLossPayee} onChange={(e) => setVclLossPayee(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            <div className="masterCert__checkboxItem">
              <Checkbox checked={vclChecked} onChange={(e) => setVclChecked(e.checked ?? false)} />
              <span className="masterCert__checkboxItemLabel" style={{ fontWeight: 600 }}>VEH COLLISION LOSS</span>
            </div>
            <InputText className="masterCert__input masterCert__inputFull" />
            <Checkbox checked={false} />
          </div>
          <InputText value={vclPolicyNum} onChange={(e) => setVclPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={vclEffDate} onChange={(e) => setVclEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={vclExpDate} onChange={(e) => setVclExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          {pdLimitsBlock(vclAcv, setVclAcv, vclAgreedAmt, setVclAgreedAmt, vclStatedAmt, setVclStatedAmt)}
        </div>

        <div className="acord23__covRow">
          <Dropdown value={vcInsrLtr} onChange={(e) => setVcInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={vcLossPayee} onChange={(e) => setVcLossPayee(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            {chk('a23VcComp', 'VEH COMP', vcVehComp, setVcVehComp)}
            {chk('a23VcOtc', 'VEH OTC', vcVehOtc, setVcVehOtc)}
            <InputText className="masterCert__input masterCert__inputFull" />
            <Checkbox checked={false} />
          </div>
          <InputText value={vcPolicyNum} onChange={(e) => setVcPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={vcEffDate} onChange={(e) => setVcEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={vcExpDate} onChange={(e) => setVcExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          {pdLimitsBlock(vcAcv, setVcAcv, vcAgreedAmt, setVcAgreedAmt, vcStatedAmt, setVcStatedAmt)}
        </div>
        <div className="acord23__covRow">
          <Dropdown value={propInsrLtr} onChange={(e) => setPropInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={propLossPayee} onChange={(e) => setPropLossPayee(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            <span className="acord23__typeLabel">PROPERTY</span>
            {chk('a23PropBasic', 'BASIC', propBasic, setPropBasic)}
            {chk('a23PropSpecial', 'SPECIAL', propSpecial, setPropSpecial)}
            {chk('a23PropBroad', 'BROAD', propBroad, setPropBroad)}
            <InputText className="masterCert__input masterCert__inputFull" />
            <Checkbox checked={false} />
          </div>
          <InputText value={propPolicyNum} onChange={(e) => setPropPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={propEffDate} onChange={(e) => setPropEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={propExpDate} onChange={(e) => setPropExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          {pdLimitsBlock(propAcv, setPropAcv, propAgreedAmt, setPropAgreedAmt, propStatedAmt, setPropStatedAmt, true, propRc, setPropRc)}
        </div>

        <div className="acord23__covRow">
          <Dropdown value={genInsrLtr} onChange={(e) => setGenInsrLtr(e.value)} options={INSR_OPTIONS} placeholder="" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
          <div style={{ justifySelf: 'center' }}><Checkbox checked={genLossPayee} onChange={(e) => setGenLossPayee(e.checked ?? false)} /></div>
          <div className="acord23__typeArea">
            <Checkbox checked={false} />
            <InputText className="masterCert__input masterCert__inputFull" />
          </div>
          <InputText value={genPolicyNum} onChange={(e) => setGenPolicyNum(e.target.value)} className="masterCert__input masterCert__inputFull" />
          <Calendar value={genEffDate} onChange={(e) => setGenEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <Calendar value={genExpDate} onChange={(e) => setGenExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
          <div className="acord23__limitsStack">
            <div className="acord23__limitRow">
              <InputText className="masterCert__input" style={{ width: 80 }} />
              <InputText className="masterCert__input" style={{ width: 80 }} />
            </div>
          </div>
        </div>

        <div className="masterCert__descriptionSection" style={{ marginTop: 16 }}>
          <div className="masterCert__descriptionTitle">REMARKS (INCLUDING SPECIAL CONDITIONS / OTHER COVERAGES) (Attach ACORD 101, Additional Remarks Schedule, if more space is required)</div>
          <InputTextarea maxLength={2000} value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={3} className="masterCert__descriptionTextarea" />
        </div>

        <div className="acord23__bottomGrid">
          <div>
            <div className="acord23__bottomTitle">ADDITIONAL INTEREST</div>
            <div style={{ fontSize: '0.75rem', color: '#555', marginBottom: 8 }}>Select one of the following:</div>

            <div className="acord23__aiOption">
              <RadioButton inputId="aiOpt1" name="aiOption" value="added" checked={aiOption === 'added'} onChange={(e) => setAiOption(e.value)} />
              <label htmlFor="aiOpt1">The additional interest described below has been added to the policy(ies) listed herein by policy number(s)</label>
            </div>
            <div className="acord23__aiOption">
              <RadioButton inputId="aiOpt2" name="aiOption" value="requested" checked={aiOption === 'requested'} onChange={(e) => setAiOption(e.value)} />
              <label htmlFor="aiOpt2">A request has been submitted to add the additional interest described below to the policy(ies) listed herein by policy number(s).</label>
            </div>

            <div style={{ marginTop: 12 }}>
              <div className="masterCert__contactLabel" style={{ marginBottom: 6 }}>VEHICLE / EQUIPMENT INTEREST</div>
              <div style={{ display: 'flex', gap: 24, marginBottom: 12 }}>
                {chk('a23AiLeased', 'LEASED', aiLeased, setAiLeased)}
                {chk('a23AiFinanced', 'FINANCED', aiFinanced, setAiFinanced)}
              </div>
            </div>

            <div className="masterCert__contactLabel" style={{ marginBottom: 6 }}>NAME AND ADDRESS OF THE ADDITIONAL INTEREST</div>
            <InputText maxLength={100} value={aiName} onChange={(e) => setAiName(e.target.value)} placeholder="Name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={aiAddress1} onChange={(e) => setAiAddress1(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={aiAddress2} onChange={(e) => setAiAddress2(e.target.value)} placeholder="Address line 2" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={aiAddress3} onChange={(e) => setAiAddress3(e.target.value)} placeholder="Address line 3" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <div className="masterCert__addressGrid">
              <InputText maxLength={100} value={aiCity} onChange={(e) => setAiCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={50} value={aiState} onChange={(e) => setAiState(e.target.value)} placeholder="State" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={20} value={aiZip} onChange={(e) => setAiZip(e.target.value)} placeholder="Zip" className="masterCert__input masterCert__inputFull" />
            </div>
          </div>

          <div>
            <div className="acord23__bottomTitle">CANCELLATION</div>
            <div className="masterCert__disclaimer" style={{ marginBottom: 12, fontSize: '0.72rem' }}>
              Should any of the above described policies be cancelled before the expiration date thereof, notice will be delivered in accordance with the policy provisions.
            </div>

            <div className="acord23__cancCheckGrid">
              {chk('a23CancAddlIns', 'ADDITIONAL INSURED', cancAddlInsured, setCancAddlInsured)}
              {chk('a23CancLossPayee', 'LOSS PAYEE', cancLossPayee, setCancLossPayee)}
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a23CancLenders" checked={cancLendersLossPayee} onChange={(e) => setCancLendersLossPayee(e.checked ?? false)} />
                <label htmlFor="a23CancLenders" className="masterCert__checkboxItemLabel">LENDER'S LOSS PAYEE</label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Checkbox checked={false} />
                <InputText className="masterCert__input" style={{ width: '100%' }} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <div className="masterCert__contactLabel" style={{ marginBottom: 4 }}>LOAN / LEASE NUMBER</div>
              <InputText maxLength={30} value={loanLeaseNumber} onChange={(e) => setLoanLeaseNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>

            <div>
              <div className="masterCert__authRepLabel">AUTHORIZED REPRESENTATIVE</div>
              <div className="masterCert__authRepRow">
                <Dropdown value={authRepSignature} onChange={(e) => setAuthRepSignature(e.value)} options={signatureOptions} optionLabel="label" optionValue="value" placeholder="Select signature:" className="masterCert__input masterCert__authRepDropdown" emptyMessage="No available options" />
                <Button label="Create New" className="p-button-outlined carrierDialog__secondaryBtn" onClick={() => setShowAddSignature(true)} />
              </div>
              {signaturePreviewUrl && (
                <div style={{ marginTop: 8 }}>
                  <img src={signaturePreviewUrl} alt="Signature preview" style={{ maxHeight: 60, maxWidth: 280, objectFit: 'contain', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 8px', background: '#fff' }} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="masterCert__acordFooter">
          <div>ACORD 23 (2010/05)</div>
          <div>&copy; ACORD CORPORATION 1993-2009. All rights reserved.</div>
        </div>
      </div>

      <CreateNewCarriers open={showCreateCarrier} onClose={() => setShowCreateCarrier(false)} />
      <AddNewSignature open={showAddSignature} onClose={() => setShowAddSignature(false)} onSaved={refetchSignatures} />
    </>
  );
}
